<template>
  <!-- READ ONLY MODE -->

  <div class="option-section" v-if="mode === 'VIEW'">
    <div class="question-container">
      <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
      <p class="question_body ql-editor p-0" v-html="question.formattedBody"></p>
    </div>
    <div v-if="question.measurementUnit != 'Feet-Inches' && question.subType != 'bloodpressure'">
      <input type="text" class="input-text readonly col-md-3 weight_input" :placeholder="getplaceholdertext(question)" readonly />
      <span class="ml-10">{{ question.measurementUnit }}</span>
    </div>
    <div v-if="question.measurementUnit == 'Feet-Inches'">
      <input type="text" class="input-text readonly col-md-3 weight_input" :placeholder="getplaceholdertext(question)" readonly />
      <span class="ml-10 mr-10">ft</span>
      <input type="text" class="input-text readonly col-md-3 weight_input" :placeholder="getplaceholdertext(question)" readonly />
      <span class="ml-10 mr-2">in</span>
    </div>
    <div v-if="question.subType === 'bloodpressure'">
      <input type="text" class="input-text readonly col-md-3" placeholder="Systolic value" readonly />
      <span class="ml-10 mr-10">/</span>
      <input type="text" class="input-text readonly col-md-3" placeholder="Diastolic value" readonly />
      <span class="ml-10 mr-2">mmHg</span>
    </div>
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'">
    <div class="p-0">
      <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
        <span
          class="add-help-text"
          :class="{
            'right-position': activityDetails.customParticipantMessaging
          }"
          :style="{
            color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Help
        </span>
      </div>
      <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
        <span
          class="add-help-text"
          :style="{
            color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Message
        </span>
      </div>
      <quill-editor class="bg-white mt-30 editorqution" v-model="question.formattedBody" :disabled="question.type === 'Default'" :options="commonProps.editorOptionForQuestion"></quill-editor>
    </div>
    <!-- help content -->
    <div v-if="isAddHelpEnabled">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-40 mb-10" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>
    <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30 mt-30">
      <div class="col-md-11 p-0">
        <h5 class="mt-10">Message</h5>
        <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
      </div>
      <div class="col-md-1 p-0">
        <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
          <img src="static/img/delete.svg" />
        </button>
      </div>
    </div>
    <div class="row mt-10">
      <div class="col-md-3 pl-0 pt-10 measurement-size">
        <h5>Measurement type</h5>
        <select
          class="selectpicker"
          v-model="question.subType"
          @change="onChangeMeasurementType"
          style="background-color: #fff;
              border: solid 2px #d3dfe4; width:100%;"
        >
          <option value="weight">Weight</option>
          <option value="height">Height/Length</option>
          <option value="bloodpressure">Blood pressure</option>
          <option value="measurements">Measurements</option>
          <option value="temperature">Temperature</option>
        </select>
      </div>
      <div class="col-md-3 pt-10 pr-0 measurement-size ">
        <h5>Unit type</h5>
        <select
          :disabled="question.subType == 'bloodpressure'"
          :class="question.subType == 'bloodpressure' ? 'removeimgbloodpressure' : 'selectpicker'"
          v-model="question.measurementUnit"
          style="
              border: solid 2px #d3dfe4; width:auto;
              background-color:#fff;
              "
        >
          <option v-for="unit in getUnitTypeOptions(question.subType)" :value="unit.value" :key="unit.value">{{ unit.name }}</option>
        </select>
      </div>
      <div class="col-lg-1 p-0 score_cls mt-9">
        <h5 class="score_text">Score</h5>
        <integer-plusminus :min="0" :max="999" :step="1" :vertical="false" :disabled="activityDetails && activityDetails.canScoreResponses == false" formName="score" class="score_input" v-model.number="question.score">
          <input value="999" v-model.number="question.score" oninput="javascript:this.value = Math.abs(this.value); this.value = Math.round(this.value); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="3" type="number" class="integer-plus-minus-input" />
        </integer-plusminus>
      </div>
    </div>
    <div class="row">
      <div class="pl-0 pt-20 fs-14 col-md-3 measurement-size">
        <label class>
          <input type="checkbox" v-model="question.isDisplayMinumumValueField" @change="getValuechangeMin" />
          <span class="text-align">Enable minimum value</span>
        </label>
        <div class="col-md-12 pl-0" v-if="question.isDisplayMinumumValueField">
          <div class="mb-20 pl-0">
            <b-form-input v-if="question.subType == 'bloodpressure'" type="number" class="fs-15 pt-8 mt-10 field-h40" v-model="question.systolicMinimumValue" placeholder="Systolic minimum value" size="md"> </b-form-input>
            <b-form-input v-if="question.subType == 'bloodpressure'" type="number" class="fs-15 pt-8 mt-10 field-h40" v-model="question.diastolicMinimumValue" placeholder="Diastolic minimum value" size="md"> </b-form-input>
            <b-form-input v-else type="number" class="fs-15 mt-10 pt-8 field-h40" v-model="question.minimumValue" :placeholder="'Minimum ' + question.subType" size="md"></b-form-input>
          </div>
        </div>
      </div>
      <div class="fs-14 pt-20 col-md-3 measurement-size">
        <label class>
          <input type="checkbox" v-model="question.isDisplayMaximumValueField" @change="getValuechangeMax()" />
          <span class="text-align">Enable maximum value</span>
        </label>
        <div class="col-md-12 pl-0" v-if="question.isDisplayMaximumValueField">
          <div class="pl-0">
            <b-form-input v-if="question.subType == 'bloodpressure'" type="number" class="fs-15 pt-8 mt-10 field-h40" v-model="question.systolicMaximumValue" placeholder="Systolic maximum value" size="md"> </b-form-input>
            <b-form-input v-if="question.subType == 'bloodpressure'" type="number" class="fs-15 pt-8 mt-10 field-h40" v-model="question.diastolicMaximumValue" placeholder="Diastolic maximum value" size="md"> </b-form-input>
            <b-form-input v-else type="number" class="fs-15 pt-8 mt-10 field-h40" v-model="question.maximumValue" :placeholder="'Maximum  ' + question.subType" size="md"></b-form-input>
          </div>
        </div>
      </div>
      <div class="pl-0  fs-15" v-if="question.subType == 'measurements'">
        <div class="pl-0 pr-0 pt-20 fs-15 col-md-2">
          <label class>
            <input type="checkbox" v-model="question.isDecimalField" />
            <span class="text-align">Decimal Places</span>
          </label>
          <div class="col-md-12 pl-0" v-if="question.isDecimalField">
            <div class="mb-20 pl-0">
              <b-form-input v-if="question.subType == 'measurements'" type="number" class="fs-15 pt-8 mt-10 field-h40" v-model="question.decimalPlace" placeholder="Decimal Places" size="md"> </b-form-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IntegerPlusminus } from "vue-integer-plusminus";
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import { quillEditor } from "vue-quill-editor";
import $ from "jquery";

export default {
  name: "ActivityStepMeasurements",
  mixins: [activityStepCustomMessage],
  data() {
    return {
      unitType: {
        weight: [
          {
            name: "Pounds (lbs)",
            value: "lbs"
          },
          {
            name: "Kilograms (kg)",
            value: "kg"
          }
        ],
        height: [
          {
            name: "Feet (ft)/Inches (in)",
            value: "Feet-Inches"
          },
          {
            name: "Centimeters (cm)",
            value: "cm"
          }
        ],
        bloodpressure: [
          {
            name: "mmHg",
            value: "mmHg"
          }
        ],
        measurements: [
          {
            name: "%",
            value: "%"
          },
          {
            name: "beats/min",
            value: "beats/min"
          },
          {
            name: "breaths/min",
            value: "breaths/min"
          },
          {
            name: "C",
            value: "C"
          },
          {
            name: "cm",
            value: "cm"
          },
          {
            name: "cmHg",
            value: "cmHg"
          },
          {
            name: "F",
            value: "F"
          },
          {
            name: "g",
            value: "g"
          },
          {
            name: "Hz",
            value: "Hz"
          },
          {
            name: "in",
            value: "in"
          },
          {
            name: "K",
            value: "K"
          },
          {
            name: "kcal/day",
            value: "kcal/day"
          },
          {
            name: "kg",
            value: "kg"
          },
          {
            name: "kg/m2",
            value: "kg/m2"
          },
          {
            name: "LB",
            value: "LB"
          },
          {
            name: "m",
            value: "m"
          },
          {
            name: "m2",
            value: "m2"
          },
          {
            name: "MET",
            value: "MET"
          },
          {
            name: "mm",
            value: "mm"
          },
          {
            name: "mmHg",
            value: "mmHg"
          },
          {
            name: "Pa",
            value: "Pa"
          },
          {
            name: "RATIO",
            value: "RATIO"
          },
          {
            name: "Watt",
            value: "Watt"
          }
        ],
        temperature: [
          {
            name: "Degree Fahrenheit",
            value: "Degree Fahrenheit"
          },
          {
            name: "Degree Celsius",
            value: "Degree Celsius"
          }
        ]
      },
      isAddHelpEnabled: false
    };
  },
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    activityDetails: {},
    commonProps: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  components: {
    IntegerPlusminus,
    quillEditor
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  mounted() {
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
    this.init();
  },
  methods: {
    getValuechangeMax() {
      this.question.maximumValue = null;
      this.question.systolicMaximumValue = null;
      this.question.diastolicMaximumValue = null;
    },
    getValuechangeMin() {
      this.question.minimumValue = null;
      this.question.systolicMinimumValue = null;
      this.question.diastolicMinimumValue = null;
    },

    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };
      if (!question.formattedBody || this.stripHtml(question.formattedBody).trim() == "") {
        errorObj.isValid = false;
        errorObj.msg = "Step is required.";
        return errorObj;
      }
      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }
      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }
      let fieldValue = "";
      let isDecimalAllowed = true;
      if (question.subType == "weight") {
        fieldValue = "Weight";
      } else if (question.subType == "height") {
        fieldValue = "Height/Length";
      } else if (question.subType == "measurements") {
        fieldValue = "value";
      } else if (question.subType === "temperature") {
        fieldValue = "Temperature";
      }
      if (question.isDisplayMinumumValueField && question.subType !== "bloodpressure") {
        if (!question.minimumValue && typeof question.minimumValue !== "number") {
          errorObj.isValid = false;
          errorObj.msg = `Min ${fieldValue} is required.`;
          return errorObj;
        }
      }
      if (question.isDisplayMaximumValueField && question.subType !== "bloodpressure") {
        if (!question.maximumValue) {
          errorObj.isValid = false;
          errorObj.msg = `Max ${fieldValue} is required.`;
          return errorObj;
        }
      } else if (question.subType == "bloodpressure") {
        isDecimalAllowed = false;
        if (question.isDisplayMinumumValueField) {
          if (!question.systolicMinimumValue && typeof question.systolicMinimumValue !== "number") {
            errorObj.isValid = false;
            errorObj.msg = `Min Systolic value is required.`;
            return errorObj;
          } else if (!question.diastolicMinimumValue && typeof question.diastolicMinimumValue !== "number") {
            errorObj.isValid = false;
            errorObj.msg = `Min Diastolic value is required.`;
            return errorObj;
          }
        }
        if (question.isDisplayMaximumValueField) {
          if (!question.systolicMaximumValue && typeof question.systolicMaximumValue !== "number") {
            errorObj.isValid = false;
            errorObj.msg = `Max Systolic value is required.`;
            return errorObj;
          } else if (!question.diastolicMaximumValue && typeof question.diastolicMaximumValue !== "number") {
            errorObj.isValid = false;
            errorObj.msg = `Max Diastolic value is required.`;
            return errorObj;
          }
        }
        if (!isDecimalAllowed || (question && question.isDecimalField != undefined && !question.isDecimalField)) {
          let numberFormat = /[/\./g]/;
          if (numberFormat.test(question.systolicMinimumValue) || numberFormat.test(question.diastolicMinimumValue)) {
            errorObj.isValid = false;
            errorObj.msg = `Decimals are not allowed for Min value. Enter a whole number.`;
            return errorObj;
          }
        }
        if (!isDecimalAllowed || (question && question.isDecimalField != undefined && !question.isDecimalField)) {
          let numberFormat = /[/\./g]/;
          if (numberFormat.test(question.systolicMaximumValue) || numberFormat.test(question.diastolicMaximumValue)) {
            errorObj.isValid = false;
            errorObj.msg = `Decimals are not allowed for Max value. Enter a whole number.`;
            return errorObj;
          }
        }
      }
      if (question.isDecimalField) {
        if (!question.decimalPlace) {
          errorObj.isValid = false;
          errorObj.msg = `Decimal Places is required.`;
          return errorObj;
        }
        if (question.subType == "measurements") {
          const present = 0;
          const isDecimalPresent = question.decimalPlace.indexOf(".", present);
          if (isDecimalPresent != -1) {
            errorObj.isValid = false;
            errorObj.msg = `Enter a whole number.`;
            return errorObj;
          }
        }
      }

      if (question.subType == "weight" || question.subType == "height" || question.subType == "bloodpressure" || question.subType == "measurements" || question.subType == "temperature") {
        if (parseInt(question.minimumValue) > parseInt(question.maximumValue)) {
          errorObj.isValid = false;
          errorObj.msg = "Maximum value cannot be less than minimum value.";
          return errorObj;
        } else if (parseInt(question.systolicMinimumValue) > parseInt(question.systolicMaximumValue) || parseInt(question.diastolicMinimumValue) > parseInt(question.diastolicMaximumValue)) {
          errorObj.isValid = false;
          errorObj.msg = "Maximum value cannot be less than minimum value.";
          return errorObj;
        }
      }
      return { isValid: true };
    },

    // measurement placeholder
    getplaceholdertext(question) {
      if (question.subType == "weight") {
        return "Enter weight";
      } else if (question.subType == "height") {
        return "Enter height/length";
      } else if (question.subType == "bloodpressure") {
        return "Enter blood pressure";
      } else if (question.subType == "measurements") {
        return "Enter value here";
      } else if (question.subType === "temperature") {
        return "Enter temperature";
      }
    },

    onChangeMeasurementType() {
      $(".editorqution .ql-editor").attr("data-placeholder", "Enter question");
      if (this.question.subType == "weight") {
        this.question.measurementUnit = "lbs";
      }
      if (this.question.subType == "height") {
        this.question.measurementUnit = "Feet-Inches";
      }
      if (this.question.subType == "bloodpressure") {
        this.question.measurementUnit = "mmHg";
      }
      if (this.question.subType === "temperature") {
        this.question.measurementUnit = "Degree Fahrenheit";
        $(".editorqution .ql-editor").attr("data-placeholder", "Enter temperature");
      }
      if (this.question.subType == "measurements") {
        this.question.measurementUnit = "%";
      }
    },
    getUnitTypeOptions(subType) {
      const options = this.unitType[subType];
      return options;
    },
    init() {
      if (!this.question.id) {
        this.$set(this.question, "score", 0);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.removeimgbloodpressure {
  background-image: none;
  background-color: #f2f2f2 !important;
}
.radio-option {
  margin: 0px;
  label {
    padding-left: 5px;
  }
}
.integer-plus-minus-input {
  width: 2em;
  border: none;
  padding-left: 2px;
  text-align: left !important;
}
.activity-configurator-step-edit-mode .score_cls {
  margin-left: 0.5%;
}
.activity-configurator-step-edit-mode .score_text {
  top: 5px;
}
.activity-configurator-step-edit-mode .score_input {
  top: 33px;
}
.col-md-4 .activity-configurator-step-view-mode .readonly.weight_input {
  width: 42%;
  max-width: 50%;
  padding: 0;
}
.col-md-6 .activity-configurator-step-view-mode .input-text {
  max-width: 40%;
  padding: 0;
}
.measurement-size {
  width: 20%;
}
.activity-configurator-step-edit-mode {
  .score_input {
    top: 28px;
  }
}
.add-help-text {
  right: 533px;
  padding: 12px 13px;
  top: -38px;
  &.right-position {
    right: 637px;
  }
}
</style>
